import * as administrator from "./administrator";
import * as common from "./common";
import * as company from "./company";

const deleteMethod = {
  administrator,
  common,
  company,
};

export default deleteMethod;
